import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { Common } from '../../../../../core/common';
import { IMatrisProps, IMatrixQuestion, IQuestionChoice } from '../../../../../models/components/add-activity-survey-questions';
import { IAction, IAppState } from '../../../../../models/action/core';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import EdiText from 'react-editext';
import { Confirm } from '../../../../../components/notification/main';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;

interface IMatrisState {
    isOpen: boolean;
    choiceType: 0 | 1 | -1; // 0: Col, 1: Row, -1: None
    choiceText: string;
}

export class Matris extends Component<IMatrisProps, IMatrisState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            isOpen: false,
            choiceType: -1,
            choiceText: ''
        };

        this.props.deleteQuestion.bind(this);
    }

    componentDidMount () {
        this.updateOrders();
    }

    componentDidUpdate (prevProps: IMatrisProps) {
        if (prevProps.baseDisplayOrder !== this.props.baseDisplayOrder) {
            this.updateOrders();
        }
    }

    updateOrders = () => {
        const question = this.props.question;
        if (question && question.matrixQuestions && question.matrixQuestions.length) {
            const matrixQuestionList = question.matrixQuestions.sort((a, b) => a.displayOrder - b.displayOrder);

            let i = this.props.baseDisplayOrder;
            matrixQuestionList.forEach((q) => {
                q.displayOrder = i;
                i = i + 1;
            });

            question.matrixQuestions = matrixQuestionList;
            this.props.editQuestion(question);
        }
    }

    handleDelete = () => {
        this.props.deleteQuestion(this.props.question.displayOrder, false, T.t('r_delete_survey_question_matrix'));
    };

    onClose = () => {
        this.setState({ isOpen: false, choiceType: -1, choiceText: '' });
    }

    onOpen = (type: 0 | 1) => {
        this.setState({ isOpen: true, choiceType: type });
        setTimeout(() => {
            const item = document.getElementById('choiceText');
            if (item) {
                item.focus();
            }
        }, 500);
    }

    addChoice = () => {
        if (this.props.question && this.state.choiceText) {
            const question = this.props.question;

            if (question.questionChoices && this.state.choiceType === 0) {
                let endIndex = 1;
                if (question.questionChoices.length > 0) {
                    endIndex = question.questionChoices.sort((a, b) => b.displayOrder - a.displayOrder)[0].displayOrder + 1; 
                }

                const item: IQuestionChoice = { surveyQuestionChoiceId: '0', displayOrder: endIndex, text: this.state.choiceText };
                question.questionChoices.push(item);
                this.props.editQuestion(question);
            } else if (question.matrixQuestions && this.state.choiceType === 1) {
                let endIndex = question.displayOrder;
                if (question.matrixQuestions.length > 0) {
                    endIndex = question.matrixQuestions.sort((a, b) => b.displayOrder - a.displayOrder)[0].displayOrder + 1; 
                }
        
                const item: IMatrixQuestion = { surveyQuestionId: '0', displayOrder: endIndex, description: this.state.choiceText };
                question.matrixQuestions.push(item);
                this.props.copy(endIndex, '', true);
                this.props.editQuestion(question);
            }

            this.onClose();
        }
    }

    deleteChoiceHandle = (choiceType: 0 | 1, displayOrder: number) => {
        Confirm.setConfirm(
            'normal',
            () => this.deleteChoice(choiceType, displayOrder),
            choiceType ? 'Satırı silmek istediğinize emin misiniz?' : 'Sütunu silmek istediğinize emin misiniz?',
            null,
            null,
            undefined,
            true
        );
    }

    deleteChoice = (choiceType: 0 | 1, displayOrder: number) => {
        if (this.props.question) {
            const question = this.props.question;

            if (question.questionChoices && choiceType === 0) {
                const sourceItem = question.questionChoices.find(q => q.displayOrder === displayOrder);

                if (sourceItem) {
                    question.questionChoices.splice(sourceItem.displayOrder, 1); 
                    question.questionChoices.filter(q => q.displayOrder >= displayOrder).forEach(q => q.displayOrder = q.displayOrder - 1);
                    this.props.editQuestion(question);
                }
            } else if (question.matrixQuestions && question.matrixQuestions.length > 1 && choiceType === 1) {
                const sourceItemIndex = question.matrixQuestions.findIndex(q => q.displayOrder === displayOrder);

                if (sourceItemIndex !== -1) {
                    question.matrixQuestions.splice(sourceItemIndex, 1); 
                    question.matrixQuestions.filter(q => q.displayOrder >= displayOrder).forEach(q => q.displayOrder = q.displayOrder - 1);
                    this.props.editQuestion(question);
                    if (this.props.deleteQuestionConfirm) {
                        this.props.deleteQuestionConfirm(displayOrder, true);
                    }
                }
            }
        }
    }

    handleChangeChoiceText = (e: any) => {
        if (e && e.target) {
            this.setState({ choiceText: e.target.value });
        }
    }

    handleSave = (text: string, choiceType: 0 | 1, displayOrder: number) => {
        if (this.props.question) {
            const question = this.props.question;

            if (question.questionChoices && choiceType === 0) {
                question.questionChoices.filter(q => q.displayOrder === displayOrder).forEach(q => q.text = text);
                this.props.editQuestion(question);
            } else if (question.matrixQuestions && question.matrixQuestions.length > 0 && choiceType === 1) {
                question.matrixQuestions.filter(q => q.displayOrder === displayOrder).forEach(q => q.description = text);
                this.props.editQuestion(question);
            }
        }
    }

    onKeyPress = (e: any) => {
        if(e && (e.keyCode === 13 || e.charCode === 13)) {
            this.addChoice();
        }
    }

    public render() {
        return (
            <React.Fragment>
                {
                    this.props.question.questionChoices && this.props.question.questionChoices.length <= 10 ? (
                    <a  onClick={this.onOpen.bind(this, 0)} className="ml-auto survey_table_add_btn add_column"><i className="material-icons">add</i></a>
                    ) : ''
                }
                <div className="w-85  table-responsive scroll">
                            <table className="table survey_table mb-0">
                                <thead >
                                    <tr className="choose_col">
                                        <th className="first_th_blank" />
                                        {this.props.question.questionChoices
                                            ? this.props.question.questionChoices
                                                .sort((a, b) => a.displayOrder - b.displayOrder)
                                                .map((choice, index) => (
                                                    <th key={index} className="first_th">
                                                        {this.props.question.questionChoices!.length > 1 ? (
                                                            <a onClick={this.deleteChoiceHandle.bind(this, 0, choice.displayOrder)} className="table_col_delete">
                                                                <i className="material-icons">close</i>
                                                            </a>
                                                        ) : '' }
                                                        <EdiText
                                                            type="text"
                                                            className='survey_column_text'
                                                            // tslint:disable-next-line: jsx-no-lambda
                                                            onSave ={(value: any) => this.handleSave(value, 0, choice.displayOrder)}
                                                            value={choice.text}
                                                            showButtonsOnHover= {true}
                                                            saveButtonClassName = "hideEditextSaveButton"
                                                            cancelButtonClassName = "hideEditextCancelButton"
                                                            validationMessage= {T.t('r_editext_character_error', { 0: 1 })}
                                                            // tslint:disable-next-line:jsx-no-lambda
                                                            validation={val => val.trim().length >= 1}
                                                            editOnViewClick={true}
                                                            submitOnEnter={true}
                                                            cancelOnEscape={true}
                                                            cancelOnUnfocus={true}
                                                            tabIndex={0}
                                                        />
                                                    </th>
                                                ))
                                            : ''}
                                            
                                    </tr>
                                    
                                </thead>
                                <tbody>
                                    {this.props.question.matrixQuestions
                                        ? this.props.question.matrixQuestions
                                            .sort((a, b) => a.displayOrder - b.displayOrder)
                                            .map((question, index) => (
                                                <tr key={index} className="choose_row">
                                                    <td className="first_td">
                                                        <EdiText
                                                            type="text"
                                                            // tslint:disable-next-line: jsx-no-lambda
                                                            onSave ={(value: any) => this.handleSave(value, 1, question.displayOrder)}
                                                            value={question.description}
                                                            showButtonsOnHover= {true}
                                                            saveButtonClassName ="hideEditextSaveButton"
                                                            cancelButtonClassName ="hideEditextCancelButton"
                                                            validationMessage= {T.t('r_editext_character_error', { 0: 1 })}
                                                            // tslint:disable-next-line:jsx-no-lambda
                                                            validation={val => val.trim().length >= 1}
                                                            editOnViewClick={true}
                                                            submitOnEnter={true}
                                                            cancelOnEscape={true}
                                                            cancelOnUnfocus={true}
                                                            tabIndex={0}
                                                        />
                                                        {this.props.question.matrixQuestions!.length > 1 ? (
                                                            <a onClick={this.deleteChoiceHandle.bind(this, 1, question.displayOrder)} className="table_row_delete" style={{ marginTop: -29 }}>
                                                                <i className="material-icons">close</i>
                                                            </a>
                                                        ) : '' }
                                                    </td>

                                                    {this.props.question.questionChoices
                                                        ? this.props.question.questionChoices
                                                                .map((choice, inIndex) => (
                                                                    <td key={inIndex}>
                                                                        <div className="tick-radio position-relative">
                                                                            <div className="control_group survey_choose">
                                                                                <label className="control control--radio">
                                                                                    <input type="radio" name="radio" checked={true} />
                                                                                    <div className="control__indicator" />
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    
                                                                ))
                                                        : ''}
                                                </tr>
                                            ))
                                        : ''}
                                    <tr>
                                        <td style={{ borderTop: 'none' }}>
                                            <a onClick={this.onOpen.bind(this, 1)} className="survey_table_add_btn">
                                                <i className="material-icons">add</i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>     
                </div>
                <div>
                    <div className="btn_container">
                        <span className="move_btn" {...this.props.dragHandleProps}>
                            <i className="material-icons">open_with</i>
                        </span>
                        <span className="delete_btn" onClick={this.handleDelete}>
                            <i className="material-icons">close</i>
                        </span>
                    </div>
                </div>

                <Modal isOpen={this.state.isOpen} toggle={this.onClose}>
                    <div className="assignment-feedback bulk-grade" id="add-forum-modal">
                        <div>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h6 className="modal-title d-inline-flex align-items-center" id="exampleModalLabel">
                                        {T.t('r_add_choiche_upper')}
                                    </h6>
                                    <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-input form-group note-pad mb-0" style={{ paddingBottom: '15px', minHeight: 0 }}>
                                        <input type="text" id="choiceText" placeholder={T.t('r_enter_choice')} onChange={this.handleChangeChoiceText} onKeyPress={this.onKeyPress} />
                                        <span className="highlight" />
                                        <span className="bar" />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-gray-outline" onClick={this.onClose} data-dismiss="modal">{T.t('r_gen_cancel')}</button>
                                    <button type="button" onClick={this.addChoice} className="btn btn-gray">{T.t('r_gen_save')}</button>
                                </div>
                            </div>
                        </div>
                    </div>                          
                </Modal >
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IMatrisProps): IMatrisProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IMatrisProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CMatris = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Matris);

export default CMatris;
